import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=15dc04d7&scoped=true"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=15dc04d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dc04d7",
  null
  
)

export default component.exports